import {
  PLATES,
  GET_PLATES,
  GET_PLATES_ERROR,
  GET_PLATES_SUCCESS,
  ASSIGN_PLATE_MUKEB,
  ASSIGN_PLATE_MUKEB_SUCCESS,
  ASSIGN_PLATE_MUKEB_ERROR,
  CANCEL_PLATE,
  CANCEL_PLATE_SUCCESS,
  CANCEL_PLATE_ERROR,
  EXPORT_PLATES_EXCEL,
  EXPORT_PLATES_EXCEL_SUCCESS,
  EXPORT_PLATES_EXCEL_ERROR,
} from 'redux/actions';

export const getPlates = (page = 1, filters = {}) => ({
  type: GET_PLATES,
  payload: { page, filters },
});

export const getPlatesSuccess = (message = '') => ({
  type: GET_PLATES_SUCCESS,
  payload: { message },
});

export const getPlatesError = (message = '') => ({
  type: GET_PLATES_ERROR,
  payload: { message },
});

export const plates = ({ area_plate_axis: plates }) => ({
  type: PLATES,
  payload: { plates },
});

export const assignPlateMukeb = (
  plateId,
  mukebId,
  type,
  reserveType,
  standType,
  page = 1,
  filters = {}
) => ({
  type: ASSIGN_PLATE_MUKEB,
  payload: { plateId, mukebId, type, reserveType, standType, page, filters },
});

export const assignPlateMukebSuccess = (message = '') => ({
  type: ASSIGN_PLATE_MUKEB_SUCCESS,
  payload: { message },
});

export const assignPlateMukebError = (message = '') => ({
  type: ASSIGN_PLATE_MUKEB_ERROR,
  payload: { message },
});

export const cancelPlate = (plateId, page = 1, filters = {}) => ({
  type: CANCEL_PLATE,
  payload: { plateId, page, filters },
});

export const cancelPlateSuccess = (message = '') => ({
  type: CANCEL_PLATE_SUCCESS,
  payload: { message },
});

export const cancelPlateError = (message = '') => ({
  type: CANCEL_PLATE_ERROR,
  payload: { message },
});

export const exportPlatesExcel = (filters = {}, type = 'excel') => ({
  type: EXPORT_PLATES_EXCEL,
  payload: { filters, type },
});

export const exportPlatesExcelSuccess = (message = '') => ({
  type: EXPORT_PLATES_EXCEL_SUCCESS,
  payload: { message },
});

export const exportPlatesExcelError = (message = '') => ({
  type: EXPORT_PLATES_EXCEL_ERROR,
  payload: { message },
});
